/**
 * Experiments enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Experiment status labels
export const experimentStatusLabels = {
    active: 'Active',
    paused: 'Paused',
    completed: 'Completed',
};
export const experimentStatusValues = Object.keys(experimentStatusLabels);
//# sourceMappingURL=experiments.js.map